import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Banner = () => (
  <section data-testid="feature-banner" className="px-5 pb-16 sm:px-8 lg:pb-24">
    <motion.div
      initial={{ scale: 0.94, opacity: 0.6 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.1, ease: EASE }}
      className="mx-auto max-w-7xl overflow-hidden rounded-[2rem] border border-white/10 shadow-[0_50px_120px_-50px_rgba(255,106,61,0.45)]"
    >
      <img src="/images/feature-graphic.webp" alt="Spotter, your free gym buddy: workouts, videos, food diary. Train together with one code." className="block aspect-[1024/500] w-full object-cover" />
    </motion.div>
  </section>
);
